import { Suspense, useContext } from "react"
import SkeletonShippinGroupDetail from "components/Commons/Skeleton/SkeletonShippinGroupDetail"
import SummaryProductList from "components/OrderDetail/SummaryProducts/SummaryProductsList"
import { ResourcePermissionsEnum } from "enums/ResourcePermissionsEnum"
import OrderDetailHOC from "hoc/OrderDetailHOC"
import useUserPermissions from "hooks/UseUserPermissions"
import { OrderDetailType } from "types/OrderType"
import TagPrintContent from "components/OrderDetail/TagPrint/TagPrintContent"
import { AuthContext } from "context/context/AuthContext"
import { clients } from "webapp-clients/Clients"

const CanceledScreen = ({ shippinGroupDetail, order, shippingGroupId }: OrderDetailType) => {
  const {
    state: { user },
  } = useContext(AuthContext)

  const client = clients[user?.mainGroup.id as keyof typeof clients]
  const FilesList = client["FilesList" as keyof typeof client]
  const ContentFileMedia = client["ContentFileMedia" as keyof typeof client]

  const itemsOrder = shippinGroupDetail?.source.items
  const elockerInfo = shippinGroupDetail?.custom?.infoElocker
  const documents = shippinGroupDetail?.custom?.documents

  const files = shippinGroupDetail?.status
    .filter(({ media }) => media)
    .flatMap(({ media }) => media?.ref.map(({ id }) => id))

  const { permission } = useUserPermissions({ resources: [ResourcePermissionsEnum.qrcancel2, ResourcePermissionsEnum.showReversas] })

  return (
    <>
      {itemsOrder ? (
        <>
          <SummaryProductList itemsOrder={itemsOrder} groupPicking={false} titleMain={"Orden cancelada"} channel={shippinGroupDetail?.channel} />
          {order && (
            <TagPrintContent
              codigoEntrega={(elockerInfo?.isElocker && elockerInfo?.codigoEntrega) || null}
              order={order}
              shippingGroupId={shippingGroupId}
            />
          )}

          {permission[ResourcePermissionsEnum.showReversas] && ContentFileMedia && files && files.length > 0 && (
            <Suspense fallback={null}>
              <ContentFileMedia listIdFiles={files} shippingGroupId={shippingGroupId} documents={documents} />
            </Suspense>
          )}

          {!permission[ResourcePermissionsEnum.showReversas] && FilesList && (
            <Suspense fallback={null}>
              <FilesList
                documents={documents}
                channel={shippinGroupDetail?.channel}
                shippingGroupId={shippingGroupId}
              />
            </Suspense>
          )}
        </>
      ) : (
        <SkeletonShippinGroupDetail />
      )}
    </>
  )
}

export default OrderDetailHOC(CanceledScreen)
